var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"s-text",style:({..._vm.style, ..._vm.otherStyleObj}),domProps:{"innerHTML":_vm._s(_vm.safeHtml)}})
}
var staticRenderFns = []

export { render, staticRenderFns }